import { cn } from "@/utils";
import * as AccordionRoot from "@radix-ui/react-accordion";
import { MdKeyboardArrowRight } from "react-icons/md";

export interface CollapseItem {
  key: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
  children: {
    key: string;
    label: React.ReactNode | string;
  }[];
  disabled?: boolean;
  triggerClassName?: string;
}

interface Props {
  items: CollapseItem[];
  // defaultOpen?: boolean;
  onChange?: (key: string, open: boolean) => void;
  onItemActive?: (key: string) => void;
  itemClassName?: string;
  triggerClassName?: string;
  contentClassName?: string;
  childItemClassName?: string;
  iconClassName?: string;
  iconColor?: string;
  getChildItemClassName?: (
    childItem: CollapseItem["children"][number]
  ) => string;
  defaultValue?: string[];
  customItemRender?: (item: CollapseItem) => React.ReactNode;
}

export const Accordion: React.FC<Props> = ({
  items,
  // defaultOpen = true,
  onItemActive,
  itemClassName,
  triggerClassName,
  contentClassName,
  childItemClassName,
  iconClassName,
  iconColor = "#637381",
  getChildItemClassName,
  defaultValue,
  customItemRender,
}) => {
  return (
    <AccordionRoot.Root
      type="multiple"
      defaultValue={defaultValue}
      // collapsible={defaultOpen}
      className={`w-full ${itemClassName || ""}`}
    >
      {items.map((item) => (
        <AccordionRoot.Item key={item.key} value={item.key} className="w-full">
          <AccordionRoot.Trigger
            className={cn(`
              group flex items-center w-full transition-colors duration-200 gap-4 py-3 rounded
              ${triggerClassName}
              ${item.triggerClassName || ""}
            `)}
          >
            {item.icon}
            <p className="flex flex-1 items-center justify-between">
              {item.label}
              <MdKeyboardArrowRight
                className={cn(`
                w-5 h-5 -rotate-90 transition-transform duration-400 ease-in-out group-data-[state=open]:rotate-90
                ${iconClassName || ""}
                `)}
                color={iconColor}
              />
            </p>
          </AccordionRoot.Trigger>
          <AccordionRoot.Content className={`${contentClassName}`}>
            {item.children.map((child) => (
              <div
                key={child.key}
                className={cn(`
                  text-sm leading-[1.375rem] py-2 cursor-pointer transition-colors duration-200
                  ${childItemClassName}
                  ${getChildItemClassName ? getChildItemClassName(child) : ""}
                `)}
                onClick={() => onItemActive?.(child.key)}
              >
                {!!customItemRender
                  ? customItemRender(child as CollapseItem)
                  : child.label}
              </div>
            ))}
          </AccordionRoot.Content>
        </AccordionRoot.Item>
      ))}
    </AccordionRoot.Root>
  );
};
